export const lang = {
  // バリデーション
  validate: {
    required: '* Mandatory',
    required_select: 'Choose %s',
    max_length: 'Enter within %s bytes',
    file_format1: 'File name format must be "Filename"_"Version"',
    file_format2: 'File name format must be "Filename of file1"_"Version of file1"_"2"',
    incorrect: 'Invalid %s',
    not_apply: 'Invalid domain name',
    phone_number_pattern: 'Enter with ASCII number character',
    product_cd_pattern_1: '2nd character must be either \'L\',\'N\',\'E\' or \'P\'',
    product_cd_pattern_2: 'Enter 8 digit number',
    filename_pattern_1: 'Enter with either alphabet, number, period(.), hyphen(-), or underscore(_)',
    filename_pattern_2: 'Enter with either alphabet, number, period(.), hyphen(-), or underscore(_) for Filename',
    invalid_phone_number: 'Invalid phone number',
    registered: 'Specified %s is already registered',
  },
  word: {
    mail_address: 'E-mail address',
    product_cd: 'product code',
    destination: 'market region',
  },
  // 正常系
  msg: {
    // 管理者アカウント
    account: {
      not_found: 'Not found admin account',
      not_exist: 'Not exist admin account',
      regist: 'Admin account is added',
      update: 'Admin account is updated',
      remove: 'Admin account is removed',
      invalidate: 'Admin account is invalidated',
      validate: 'Admin account is validated',
    },
    // プログラムファイル
    update_file: {
      not_found: 'Not found update file',
      upload: 'Upload completed',
      no_select_file: 'No file chosen',
      confirm_update: 'Specified file is already existed. May it be overwritten?',
      confirm_remove: 'Remove an update file of %s?',
      not_exist: 'Not exist a update file',
      remove: '\'%s\' was removed',
    },
    // バージョン
    version: {
      update: 'Update information is updated',
      not_exist: 'No update file of specified version',
      publish: 'Specified update file has been published',
      unpublish: 'Specified update file has been unpublished', 
    },
    // 調整プログラム設定
    custom_file: {
      not_found: 'Not found custom update file',
      not_exist: 'Not exist custom update file',
      regist: 'Custom update file is registered',
      update: 'Custom update file is replaced',
      remove: 'Custom update file is removed',
      confirm_remove: 'Remove an custom update file of \'%s\'?',      
    }
  },
  // 異常系
  error: {
    // 管理者アカウント
    account: {
      regist: 'Failed to register admin account',
      update: 'Failed to update admin account',
      remove: 'Failed to remove admin account. Retry later',
      get: 'Failed to get detail of admin account information',
      gets: 'Failed to get admin account list',
      validate: 'Failed to validate admin account. Retry later',
      invalidate: 'Failed to invalidate admin account. Retry later',
      already: 'Already existed specified admin account',  
    },
    // プログラムファイル
    update_file: {
      gets: 'Failed to get update file list',
      upload: 'Failed to upload. Retry later',
      update: 'Failed to get update file information. Retry later',
      remove: 'Failed to remove \'%s\'. Retry later',
    },
    // バージョン
    version: {
      publish: 'Failed to publish specified update file. Retry later',
      unpublish: 'Failed to unpublish specified update file. Retry later',
      remove: 'Failed to remove update file(s) with specified version. Retry later',
      get: 'Failed to get version information',
      update: 'Failed to update version information',
    },
    // 調整プログラム設定
    custom_file: {
      regist: 'Failed to register custom file',
      update: 'Failed to update custom file',
      remove: 'Failed to remove specified custom file. Retry later',
      get: 'Failed to get custom file information',
      gets: 'Failed to get custom file list',
      not_remove: 'Unable to remove until unpublishing specified custom update file',
    }
  }
};